import type { SyncingState } from 'src/modules/syncing';

import { Actions } from '../../../../reducer';

export enum ErrorMessageType {
  Delete = 'Delete',
  Download = 'Download',
  Default = 'Default',
  Virus = 'Virus',
  Pending = 'Pending',
}

const actionToErrorMessageType: Record<string, ErrorMessageType> = {
  [Actions.RESUME_DELETE]: ErrorMessageType.Delete,
  [Actions.RESUME_GET_LINK]: ErrorMessageType.Download,
  [Actions.RESUME_UPDATE_DEFAULT]: ErrorMessageType.Default,
};

export const getErrorMessageType = ({
  action,
  resumeSyncState,
  hasVirus,
  isPending,
}: {
  action?: string;
  resumeSyncState: SyncingState;
  hasVirus: boolean;
  isPending: boolean;
}) => {
  if (
    hasVirus &&
    action !== Actions.RESUME_DELETE &&
    resumeSyncState !== 'ERROR'
  ) {
    return ErrorMessageType.Virus; // resumeErrors.hasVirus;
  }
  if (isPending) {
    return ErrorMessageType.Pending;
  }
  return action && resumeSyncState === 'ERROR'
    ? actionToErrorMessageType[action]
    : '';
};
